<template>
    <div class="app-paginator">

        <template v-for="item in currentPageItems">
            <slot name="item" :item="item"></slot>
        </template>
        
        <slot name="footer"></slot>

        <nav class="app-paginator__nav" v-show="total > itemsPerPage">
            <ul>
                <li>
                    <a class="element-button--icon element-button" v-bind:disabled="currentPage === 1 ? 'disabled' : null" href="#" @click.prevent="prevPage()" aria-label="Previous">
                        <svg aria-hidden="true" class="element-icon--pagination-left element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-pagination-left"></use></svg>
                        <span class="sr-only">Previous</span>
                    </a>
                </li>
                <template v-for="(element, index) in elements">
                    <li v-if="typeof element === 'string'"
                        :key="`index-${index}`"
                        class="element-button--icon element-button disabled"
                        aria-disabled="true">
                        <span class="page-link">{{ element }}</span>
                    </li>
                    <template v-else v-for="page in element" :key="`paginator-${page}`">
                        <li>
                            <a :class="['element-button--ghost element-button', { 'is--disabled': currentPage === page }]" href="#" @click.prevent="setPage(page)">{{ page }}</a>
                        </li>
                    </template>
                </template>
                <li>
                    <a class="element-button--icon element-button" v-bind:disabled="currentPage >= pageCount ? 'disabled' : null" href="#" @click.prevent="nextPage()" aria-label="Next">
                        <svg aria-hidden="true" class="element-icon--pagination-right element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-pagination-right"></use></svg>
                        <span class="sr-only">Next</span>
                    </a>
                </li>
            </ul>

            <!-- <div class="form-group">
                <label for="paginator-select">Items per page:</label>
                <select id="paginator-select" class="form-control mb-4" v-model="itemsPerPage">
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
            </div> -->
        </nav>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    props: {
        items: {
            type: Array,
            default: () => []
        },
        itemsPerPage: {
            type: Number,
            default: 50
        },
        startingPage: {
            type: Number,
            default: 1
        },
        onEachSide: {
            type: Number,
            default: 3
        },
        navOnTop: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            currentIndex: this.startingPage - 1
        }
    },
    computed: {
        urlWindow () {
            if (this.pageCount < (this.onEachSide * 2) + 8) {
                return {
                    first: _.range(1, this.pageCount + 1),
                    slider: null,
                    last: null
                }
            }

            return this.getUrlSlider(this.onEachSide)
        },
        elements () {
            return _.filter([
                this.urlWindow.first,
                _.isArray(this.urlWindow.slider) ? '...' : null,
                this.urlWindow.slider,
                _.isArray(this.urlWindow.last) ? '...' : null,
                this.urlWindow.last,
            ])
        },
        total () {
            return this.items.length
        },
        pageCount () {
            return Math.max(Math.ceil(this.total / this.itemsPerPage), 1)
        },
        currentPage () {
            return this.currentIndex + 1
        },
        currentPageItems () {
            const startingIndex = this.currentIndex * this.itemsPerPage
            return _.slice(this.items, startingIndex, startingIndex + this.itemsPerPage)
        }
    },
    watch: {
        items (value) {
            // if items change (filters, reset page back to start)
            this.currentIndex = 0
        }
    },
    methods: {
        getUrlSlider (onEachSide) {
            const urlWindow = onEachSide + 4;

            if (!this.pageCount) {
                return {
                    first: null,
                    slider: null,
                    last: null
                }
            }

            if (this.currentPage <= urlWindow) {
                return {
                    first: _.range(1, urlWindow + onEachSide + 1),
                    slider: null,
                    last: _.range(this.pageCount - 1, this.pageCount + 1),
                }
            } else if (this.currentPage > (this.pageCount - urlWindow)) {
                return {
                    first: _.range(1, 3),
                    slider: null,
                    last: _.range(this.pageCount - (urlWindow + (onEachSide - 1)), this.pageCount + 1)
                }
            }

            return {
                first: _.range(1, 3),
                slider: _.range(this.currentPage - onEachSide, this.currentPage + onEachSide + 1),
                last: _.range(this.pageCount - 1, this.pageCount + 1)
            }
        },
        prevPage () {
            this.currentIndex--
        },
        nextPage () {
            this.currentIndex++
        },
        setPage (page) {
            this.setIndex(page - 1)
        },
        setIndex (index) {
            this.currentIndex = index
        }
    }
}
</script>
